/* hs-eslint ignored failing-rules */
/* eslint-disable no-prototype-builtins */

import { getLanguages, CONSENT_FIELDS } from './constants';
import fetchCompanyName from './fetchCompanyName';
import { getDefaultConsentTextWithCompanyName } from './getDefaultConsentText';
// Adds translated default consent copy for missing keys in the given settings object
export default function addDefaultConsentCopy(settings) {
  return fetchCompanyName().then(companyName => {
    const newSettings = Object.assign({}, settings);
    const consentCopy = {};
    getLanguages().forEach(lang => {
      consentCopy[lang] = {
        communicationConsentCheckboxes: '',
        communicationConsentText: '',
        explicitProcessingConsentCheckboxLabel: '',
        explicitProcessingConsentText: '',
        implicitProcessingConsentText: '',
        legitimateInterestPrivacyPolicyText: '',
        privacyPolicyText: ''
      };
      CONSENT_FIELDS.forEach(field => {
        const settingsKey = `${field}:${lang}`;
        if (newSettings.hasOwnProperty(settingsKey)) {
          consentCopy[lang][field] = newSettings[settingsKey];
          delete newSettings[settingsKey];
        } else {
          consentCopy[lang][field] = getDefaultConsentTextWithCompanyName(field, {
            locale: lang,
            companyName
          });
        }
      });
    });
    const returnedSettings = {
      consentCopy
    };
    return returnedSettings;
  });
}